// extracted by mini-css-extract-plugin
module.exports = {"copy-input":"CopyInput_copy-input__OB6fj","copy-input__textarea":"CopyInput_copy-input__textarea__1cFta","copy-input__button":"CopyInput_copy-input__button__2RpT2"};